"use strict";

import { useEffect, useState } from "react";
import defaultCoinIcon from "../../assets/img/defaultCoinIcon.png";
import { tokenIcon } from "services/iconsService";

export const TokenIcon = ({ src, children, address }) => {
  const [iconSrc, setIconSrc] = useState(src);
  const [isLoadedImage, setIsLoadedImage] = useState(true);

  const handleGetIconUri = async () => {
    try {
      const fallbackIcon = await tokenIcon.getIcon(address);

      setIconSrc(fallbackIcon);
    } catch (error) {
      console.error("Failed to fetch fallback icon:", error);

      setIconSrc(defaultCoinIcon);
    } finally {
      setIsLoadedImage(false);
    }
  };

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setIsLoadedImage(false);
    };

    img.onerror = async () => {
      await handleGetIconUri();
    };

    img.src = iconSrc;
  }, [iconSrc]);

  return <>{isLoadedImage ? children(defaultCoinIcon) : children(iconSrc)}</>;
};
